export default __webpack_public_path__ + "static/media/shopee-logo-40482.fa745dee.png";